import { PropsWithChildren, useMemo } from "react";
import { KnopReact } from "./reactApp";
import { useMsal } from "@azure/msal-react";
import { ReactAppContext } from "./ReactAppContext";
import { config } from "@shared/envVariables";

export function ReactAppProvider({ children }: Readonly<PropsWithChildren>): React.JSX.Element {
  const { instance } = useMsal();
  const knopReact = useMemo(() => new KnopReact(instance, config.azureAd.scope), [instance]);

  return <ReactAppContext value={knopReact}>{children}</ReactAppContext>;
}
